import React, { useEffect, useMemo, useState } from "react";
import { api, thumbUrl } from "@/lib/apiClient";

/**
 * MobileAlbumStrip — a left-scrolling marquee of album covers shown only on
 * mobile viewports (< lg). We duplicate the covers twice so the CSS loop is
 * perfectly seamless, and plug into the same `/site/settings.album_cover_urls`
 * that the desktop `AlbumCoverRing` already uses, so admin uploads
 * automatically populate both surfaces.
 */
const DEFAULT_COVERS = [
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/h40xtrgv_White%20Dynamic%20Portrait%20Album%20Cover.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/uvilxy7y_Screenshot%202026-06-27%20143208.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/3j5yzark_Screenshot%202026-06-27%20143152.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/nbva2v2u_image_2026-06-27_144218900.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/nh90acau_10-SaadisPC.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/zimpvvl5_Screenshot%202026-06-27%20143309.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/qhb4uszu_Screenshot%202026-06-27%20143330.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/d1erwwze_Screenshot%202026-06-27%20143230.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/dvpwzu8k_X%20%2812%29.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/qdj35rdj_artwork%20%284%29.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/caoupeqm_artwork%20%283%29.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/6ib9170e_21.jpg",
];

export default function MobileAlbumStrip() {
  const [custom, setCustom] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/site/settings");
        if (data && Array.isArray(data.album_cover_urls) && data.album_cover_urls.length >= 4) {
          setCustom(data.album_cover_urls.filter(Boolean));
        }
      } catch {}
    })();
  }, []);
  const items = useMemo(() => (custom || DEFAULT_COVERS).slice(0, 14), [custom]);
  const row = [...items, ...items];

  return (
    <div className="lg:hidden -mx-5 sm:-mx-6 mb-6 overflow-hidden" data-testid="mobile-album-strip" data-nosnippet aria-hidden="true">
      <div className="relative overflow-hidden">
        <div className="flex gap-3 w-max animate-mobile-strip px-5 sm:px-6">
          {row.map((src, i) => (
            <div key={`${src}-${i}`} className="shrink-0 w-28 h-28 sm:w-32 sm:h-32 rounded-xl overflow-hidden border border-white/5 shadow-[0_6px_20px_rgba(0,0,0,0.35)]">
              <div className="w-full h-full bg-cover bg-center" style={{ backgroundImage: `url("${thumbUrl(src, 256)}")` }} role="presentation" />
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @keyframes mobile-strip-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .animate-mobile-strip {
          animation: mobile-strip-scroll 32s linear infinite;
          will-change: transform;
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-mobile-strip { animation: none; }
        }
      `}</style>
    </div>
  );
}
